/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Signin_QInputs */



/**
* | output |
* | --- |
* | "How do I sign in?" |
*
* @param {Partner_Faq_Signin_QInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_signin_q = /** @type {((inputs?: Partner_Faq_Signin_QInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Signin_QInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie melde ich mich an?")
	return /** @type {LocalizedString} */ ("How do I sign in?")
});